export enum RolesEnum {
    QA = 'QA',
    QC = 'QC',
    BUYER = 'BUYER',
    AUDITOR = 'AUDITOR',
    GUEST = 'GUEST',
    STAFF = 'STAFF',
  }
       
